module.exports = __webpack_public_path__ + "img/certif_09.6a379445.jpg";